/**
 * Die Regeln, die sich aus den eingerichteten Status ergeben (ADR 0005).
 *
 * Die Ableitung braucht von den Stammdaten nur drei Dinge: welcher Status der
 * Standard ist, welche als einsatzbereit zaehlen und welche archivieren. Name
 * und Farbe sind fuer sie ohne Belang.
 *
 * Die Regeln kommen als Eingabe herein, statt dass die Ableitung sie holt --
 * so bleibt sie eine reine Funktion und rechnet im Browser dasselbe wie auf
 * dem Server.
 */
import { STANDARD_STATUSARTEN, Verbleib } from "@thw/contracts";
/** Die Regeln aus einer Liste von Status -- aktiv oder stillgelegt, alle zaehlen. */
export function statusRegeln(arten) {
    // Fehlt ein Standard, ist die Liste kaputt. Lieber mit dem ueblichen Wert
    // weiterrechnen als jeden Artikel in einen Status ohne Namen fallen zu lassen.
    const standard = arten.find((a) => a.standard)?.schluessel ?? "einsatzbereit";
    return {
        standard,
        einsatzbereit: new Set(arten.filter((a) => a.einsatzbereit).map((a) => a.schluessel)),
        archivierend: new Set(arten.filter((a) => a.archiviert).map((a) => a.schluessel)),
        // Eine lokale Kopie von vor Vertrag 2.9 kennt das Kennzeichen nicht.
        ortUnbekannt: new Set(arten
            .filter((a) => a.ort_unbekannt === true)
            .map((a) => a.schluessel)),
    };
}
/**
 * Die Regeln der Grundausstattung. Fuer Tests -- und fuer die Oberflaeche,
 * solange sie die eingerichteten Status noch nicht geladen hat.
 */
export const STANDARD_REGELN = statusRegeln(STANDARD_STATUSARTEN);
/**
 * Fassung der Ableitungsregeln. Wird erhoeht, wenn `zustandBerechnen` bei
 * gleichem Log etwas anderes liefern soll -- dann baut der Server beim
 * naechsten Start den Lesecache neu auf.
 */
export const ABLEITUNG_FASSUNG = 2;
/**
 * Kurzform der Regeln, an der sich erkennen laesst, ob der Lesecache noch
 * dazu passt. Name und Farbe gehoeren nicht dazu: Sie aendern am Ergebnis
 * nichts.
 */
export function regelnFingerabdruck(regeln) {
    const liste = (s) => [...s].sort().join(",");
    return [
        `v${String(ABLEITUNG_FASSUNG)}`,
        `standard=${regeln.standard}`,
        `bereit=${liste(regeln.einsatzbereit)}`,
        `archiv=${liste(regeln.archivierend)}`,
    ].join(";");
}
/**
 * Der Status, den ein Wert aus dem Log tatsaechlich meint.
 *
 * Bis Vertrag 2.0 lagen Verbleib und Status in einer Liste. Eine alte
 * Korrektur auf `im_lager` meinte „alles wieder in Ordnung" -- heute ist das
 * der Standardstatus.
 */
export function statusAusLog(wert, regeln) {
    return Verbleib.options.includes(wert) ? regeln.standard : wert;
}
//# sourceMappingURL=status.js.map